/**
 * Integration-related constants
 */

import { imgCDN } from "@/constants";
import type { IntegrationType } from "./types";

/**
 * Integration platform logos
 */
export const IntegrationLogos: Record<IntegrationType, string> = {
  Jotform: `${imgCDN}/Logos and Branding/public/jotform.svg`,
  "Cognito Forms": `${imgCDN}/Logos and Branding/public/cognito-forms.svg`,
  "Go High Level": `${imgCDN}/Logos and Branding/public/gohighlevel.png`,
  SuiteDash: `${imgCDN}/Logos and Branding/public/suite-dash.png`,
};
